import React from "react";
import { connect } from "react-redux";
import {
  withStyles,
  Button,
  Typography,
  CircularProgress,
  Dialog,
  Card,
  CardContent,
} from "@material-ui/core";
import styles from "./styles";
import { compose } from "recompose";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import { updateUserPut, getUser } from "../../actions/users";
import InputLabel from "@material-ui/core/InputLabel";
import update from "immutability-helper";
import AvatarImageUploadButton from "../../components/AvatarImageUploadButton";
import withDrawer from "../../components/withDrawer";
import MenuIcon from "@material-ui/icons/Menu";
import { TextMaskCustom } from "../../components/MaskedInput";
import DefaultAvatar from "@material-ui/icons/AccountCircle";
import ShowImage from "../../components/ShowImage";
import { checkSubscription, endSubscription } from "../../actions/subscribe";
import "./styles.scss";
import { openSnackBar } from "../../actions/snack-bar";
import constants from "../../config/constant";

const byId = (id) => {
  return document.getElementById(id).value;
};

class UserProfileForm extends React.Component {
  state = {
    mobilePhone: "",
    user: { phone: "" },
    sub: null,
    ending: false,
  };

  componentDidMount() {
    this.props.dispatch(
      getUser(this.props.authentication.authenticatedUser.id, true)
    );
    this.props
      .dispatch(
        checkSubscription(this.props.authentication.authenticatedUser.id)
      )
      .then((sub) => {
        if (true) {
          if (sub.plan === "yearly-plan") {
            sub.length = "Yearly";
          } else {
            sub.length = "Monthly";
          }
          delete sub.message;
          sub.next = new Date(sub.next * 1000).toDateString();
          this.setState({ sub });
        }
      });

    let newData = {};
    newData.phone = this.props.authentication.authenticatedUser.phone.slice(2);
    this.setState({
      user: newData,
    });
  }
  handleInputChange = (e) => {
    const fieldName = e.target.name;
    let value = e.target.value;

    let newState = update(this.state, {
      user: {
        [fieldName]: { $set: value },
      },
    });
    this.setState(newState);
  };

  doUpdate = (e) => {
    e.preventDefault();

    const newData = {
      first_name: byId("first_name"),
      last_name: byId("last_name"),
      phone: byId("phone").replace(/\D/g, ""),
      email: byId("email"),
    };
    if (byId("password") !== "") {
      newData.password = byId("password");
    }
    if (newData.first_name.trim() === "" || newData.last_name.trim() === "") {
      this.props.dispatch(
        openSnackBar({
          message: constants.MESSAGE.NAME_ERROR,
        })
      );
      return;
    } else if (!constants.EMAIL_REGEX.test(newData.email)) {
      this.props.dispatch(
        openSnackBar({
          message: constants.MESSAGE.INVALID_EMAIL,
        })
      );
      return;
    } else if (
      newData.password &&
      newData.password.length > 0 &&
      newData.password.trim() === ""
    ) {
      this.props.dispatch(
        openSnackBar({
          message: constants.MESSAGE.PASSWORD_ERROR,
        })
      );
      return;
    } else {
      this.props.dispatch(
        updateUserPut(
          this.props.authentication.authenticatedUser.id,
          newData,
          this.props.history
        )
      );
    }
  };

  render() {
    const { classes, toggleDrawer, history, authentication = {} } = this.props;
    const { authenticatedUser = {} } = authentication;
    const {
      first_name = "",
      last_name = "",
      phone = "",
      email = "",
      avatar = "",
      id,
    } = authenticatedUser;
    const avatarPhotoID =
      typeof avatar === "string" &&
      avatar.length > 0 &&
      JSON.parse(avatar) &&
      JSON.parse(avatar).public_id &&
      JSON.parse(avatar).public_id !== ""
        ? JSON.parse(avatar).public_id
        : "";

    // console.log('STATE', this.state)
    // TODO avatar upload spinner
    return (
      <div className={classes.app}>
        <div className={classes.header}>
          <div
            style={{
              width: "100vw",
              display: "flex",
              position: "absolute",
              top: 0,
            }}
          >
            <MenuIcon className={classes.menu} onClick={() => toggleDrawer()} />
          </div>
          <div className={classes.photo}>
            {avatarPhotoID ? (
              <ShowImage
                publicID={avatarPhotoID}
                crop="fill"
                gravity="faces"
                width="125"
                height="125"
                radius="max"
              />
            ) : (
              <DefaultAvatar //here
                className={classes.avatarDefault}
              />
            )}
          </div>

          {/* TODO UPDATE */}

          <Typography variant="h5" className={classes.name}>
            {`${first_name} ${last_name}`}
          </Typography>

          <AvatarImageUploadButton />
        </div>

        <div className={classes.body}>
          <div style={{ maxWidth: "350px", overflow: "scroll" }}>
            <FormControl fullWidth>
              <InputLabel htmlFor="phone">Mobile Phone</InputLabel>
              <Input
                name="phone"
                id="phone"
                type="tel"
                defaultValue={phone.slice(2)}
                inputComponent={TextMaskCustom}
                value={this.state.user.phone}
                onChange={this.handleInputChange}
                disabled
              />
            </FormControl>

            <FormControl style={{ marginTop: "10px" }} fullWidth>
              <InputLabel htmlFor="first_name">First Name</InputLabel>
              <Input
                type="text"
                // fullWidth
                inputProps={{ required: true }}
                name="first_name"
                defaultValue={first_name}
                onBlur={this.handleInputBlur}
                id="first_name"
                autoComplete="nope"
              />
            </FormControl>

            <FormControl style={{ marginTop: "10px" }} fullWidth>
              <InputLabel htmlFor="last_name">Last Name </InputLabel>
              <Input
                type="text"
                // fullWidth
                inputProps={{ required: true }}
                name="last_name"
                defaultValue={last_name}
                onBlur={this.handleInputBlur}
                id="last_name"
                autoComplete="nope"
              />
            </FormControl>

            <FormControl style={{ marginTop: "10px" }} fullWidth>
              <InputLabel htmlFor="email">Email </InputLabel>
              <Input
                type="email"
                // fullWidth
                inputProps={{ required: true }}
                name="email"
                defaultValue={email}
                onBlur={this.handleInputBlur}
                id="email"
                autoComplete="nope"
              />
            </FormControl>

            {/*	TODO UPDATE PASSWORD */}

            <FormControl style={{ marginTop: "10px" }} fullWidth>
              <InputLabel htmlFor="password">Update Password</InputLabel>

              <Input
                type="password"
                // fullWidth
                inputProps={{ required: true }}
                name="password"
                value={this.state.password}
                onChange={this.handleInputChange}
                onBlur={this.handleInputBlur}
                id="password"
                autoComplete="nope"
              />
            </FormControl>
            <div className="subscription">
              {this.state.sub && this.state.sub.plan ? (
                <>
                  <p>Current Subscription</p>
                  <div className="s-wrapper">
                    <div style={{ flexGrow: "1" }}>
                      <p>
                        {this.state.sub.length} (
                        {this.state.sub.length === "Monthly"
                          ? "$4.99"
                          : "$49.99"}
                        )
                      </p>
                      {this.state.sub.ending ? null : (
                        <p className="small">
                          Next Payment: <br />
                          {this.state.sub.next}
                        </p>
                      )}
                    </div>
                    {this.state.sub.ending ? (
                      <p className="small">Ends: {this.state.sub.next}</p>
                    ) : (
                      <Button
                        variant="contained"
                        onClick={() => {
                          this.setState({ ending: true });
                        }}
                      >
                        Cancel
                      </Button>
                    )}
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>
        <FormControl fullWidth>
          <div className={classes.footer}>
            <div style={{ marginRight: "20px" }}>
              <Button onClick={() => history.push("/register")}>CANCEL</Button>

              {this.props.updatingUser ? (
                <CircularProgress color="primary" />
              ) : (
                <Button
                  variant="contained"
                  className={classes.footerButton}
                  onClick={this.doUpdate}
                  style={{ color: "white" }}
                  // disabled={this.props.updatingUser}
                >
                  SAVE
                </Button>
              )}
            </div>
          </div>
        </FormControl>
        <Dialog
          open={this.state.ending}
          onClose={() => this.setState({ ending: false })}
        >
          <Card>
            <CardContent>
              <h3>End Membership</h3>
            </CardContent>
            <CardContent>
              Are you sure that you want to end your membership.
            </CardContent>
            <CardContent>
              <div style={{ display: "flex" }}>
                <Button
                  variant="text"
                  color="primary"
                  onClick={() => this.setState({ ending: false })}
                >
                  Cancel
                </Button>
                <div style={{ flexGrow: "1" }} />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    this.props
                      .dispatch(endSubscription(id))
                      .then((res) => {
                        this.setState({ ending: false });
                        setTimeout(() => {
                          window.location.reload(true);
                        }, 1000);
                      })
                      .catch((err) => this.setState({ ending: false }));
                  }}
                >
                  End Membership
                </Button>
              </div>
            </CardContent>
          </Card>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
    updatingUser: state.users.updatingUser,
  };
};
const mapActionsToProps = (dispatch) => {
  return {
    toggleDrawer: () => dispatch({ type: "DRAWER_TOGGLED", payload: true }),
    dispatch,
  };
};

export default withDrawer(
  compose(
    connect(mapStateToProps, mapActionsToProps),
    withStyles(styles)
  )(UserProfileForm)
);
